import { MappableModel } from './mappable-model'

export class Address extends MappableModel {
  // some addresses have address, some have address_1, some have street_1
  public address: string
  public street_1: string
  public street_2: string
  public city: string
  public state_or_province: string
  public zip: string
  public country: string

  public get state(): string {
    return this.state_or_province
  }

  public set state(st: string) {
    this.state_or_province = st
  }

  /**
   * checks that 1 street,city st zip country all exist
   */
  public get valid(): boolean {
    if (!this.address && !this.street_1) return false
    if (!this.city) return false
    if (!this.state_or_province) return false
    if (!this.zip) return false
    if (!this.country) return false
    return true
  }
}
